import { MBModal } from '@shared/components/MBModal';
import { MBUrgentModalContent, MBUrgentModalContentProps } from './content';

export interface MBUrgentModalProps extends MBUrgentModalContentProps {
  visible: boolean;
}

export function MBUrgentModalComponent({ visible, ...contentProps }: MBUrgentModalProps) {
  return (
    <MBModal animationType="fade" onClose={contentProps.onClose} visible={visible}>
      <MBUrgentModalContent {...contentProps} />
    </MBModal>
  );
}
